import { DSAdditionalFilter } from 'shared-definitions/types'
import { ApiDiscoveryAdditionalFilter } from '../types.wp'

export function additionalFilterMapper(filter: ApiDiscoveryAdditionalFilter): DSAdditionalFilter {
  return {
    title: filter.title,
    value: filter.value,
    items: filter.options.map(option => ({
      name: option.name,
      value: option.value.toString(),
    })),
  }
}
